import { Directive, ElementRef, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { SxMonitoringService } from 'app/services/sx-monitoring.service';

@Directive({
    selector: '[appRouterLink]',
    standalone: false
})
export class RouterLinkDirective implements OnInit {
  public hostname = window.location.protocol + '//' + window.location.host;

  constructor(private el: ElementRef, private router: Router, private monitoringService: SxMonitoringService) {}

  ngOnInit() {}

  @HostListener('click', ['$event'])
  public onClick(eleRef) {
    const href = eleRef.target.getAttribute('href');

    if (eleRef.target.tagName === 'A' && href) {
      eleRef.preventDefault();
      //Links marked with tag name will be traced as custom events to AI
      const customEvent = eleRef.target.getAttribute('name');
      if (customEvent) this.monitoringService.logEvent(customEvent);

      if (this.isApplicationLink(href)) {
        this.router.navigate([this.getPathFromURL(href)]);
      } else {
        window.open(eleRef.target.href);
      }
    }
  }

  public getPathFromURL(url: string) {
    let el = document.createElement('a');
    el.href = url;
    return el.pathname;
  }

  public isApplicationLink(uri: string) {
    if (uri && (uri.startsWith('/secure/') || uri.includes(this.hostname))) {
      return true;
    } else {
      return false;
    }
  }
}
